import { render, staticRenderFns } from "./starryGLFoot.vue?vue&type=template&id=58544913&scoped=true&"
import script from "./starryGLFoot.vue?vue&type=script&lang=js&"
export * from "./starryGLFoot.vue?vue&type=script&lang=js&"
import style0 from "./starryGLFoot.vue?vue&type=style&index=0&id=58544913&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58544913",
  null
  
)

export default component.exports